module.exports = __webpack_public_path__ + "media/images/club-logo/1-bb1061b731beabfe7b0f6af0120899b3.png";